import { render, staticRenderFns } from "./blinds2d.vue?vue&type=template&id=628854c0&"
import script from "./blinds2d.vue?vue&type=script&lang=js&"
export * from "./blinds2d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports